import React, { forwardRef } from 'react';
import { mergeProps } from '../../../helpers/utilities';
import { useLayoutContext } from '@livekit/components-react';

function useSettingsToggle({ props }) {
  const { dispatch, state } = useLayoutContext().widget;
  const className = 'lk-button lk-settings-toggle';

  const mergedProps = React.useMemo(() => {
    return mergeProps(props, {
      className,
      onClick: () => {
        if (dispatch) dispatch({ msg: 'toggle_settings' });
      },
      'aria-pressed': state?.showSettings ? 'true' : 'false',
    });
  }, [props, className, dispatch, state]);

  return { mergedProps };
}
export const SettingsMenuToggle = forwardRef(
  function SettingsMenuToggle(props, ref) {
    const { mergedProps } = useSettingsToggle({ props });

    return (
      <button ref={ref} {...mergedProps}>
        {props.children}
      </button>
    );
  }
);
